import { useState } from 'react';

import { ListViewItem } from '@ingka/list-view';
import laptopPencil from '@ingka/ssr-icon/paths/laptop-pencil';
import { selectDrawings } from '@repo/api-adapters/selectors/drawings.selectors';
import { translate } from '@repo/phrase';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';

import { DrawingsModal } from './drawings-modal.component';

export const DrawingsSection = () => {
    const { assetId, assetType } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const drawingsCount = selectDrawings(data)?.length ?? 0;
    const [drawingsModalOpen, setDrawingsModalOpen] = useState(false);

    return (
        <>
            <ListViewItem
                id="asset-drawings"
                control="navigational"
                description={translate('asset_details_drawings_description', { number: `${drawingsCount}` })}
                controlIcon="chevronRight"
                title={translate('asset_details_drawings')}
                leadingIcon={laptopPencil}
                emphasised
                onClick={() => {
                    setDrawingsModalOpen(true);
                }}
                showDivider
            />
            <DrawingsModal
                visible={drawingsModalOpen}
                onClose={() => {
                    setDrawingsModalOpen(false);
                }}
            />
        </>
    );
};
